define.alias("ember-composable-helpers/helpers/compact", "media/helpers/compact");